// 2020-06-27export { MyGroupCorralComponent } from './my-group-corral.component';